import { j as o } from "../../../jsx-runtime-82a9ddf6.js";
const i = ({ width: r = 20, height: n = 20, className: t, style: e }) => /* @__PURE__ */ o.jsx(
  "svg",
  {
    width: r,
    height: n,
    className: t,
    style: e,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /* @__PURE__ */ o.jsxs("g", { id: "Icons / Branding", children: [
      /* @__PURE__ */ o.jsx("path", { id: "Vector", d: "M5 4.16667H15L17.5 8.33333L10.4167 16.25C10.3624 16.3054 10.2975 16.3495 10.226 16.3795C10.1544 16.4096 10.0776 16.4251 10 16.4251C9.92239 16.4251 9.84557 16.4096 9.77402 16.3795C9.70247 16.3495 9.63765 16.3054 9.58333 16.25L2.5 8.33333L5 4.16667Z", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
      /* @__PURE__ */ o.jsx("path", { id: "Vector_2", d: "M8.33341 10L6.66675 8.16667L7.16675 7.33333", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })
    ] })
  }
);
export {
  i as BrandingIcon
};
